import React from 'react';
import styled from 'styled-components';
import PageHeroSection from '../components/hero-section/PageHeroSection';
import { useLocation, useNavigate } from 'react-router-dom';
import AiFirstBusinessApplicationsImage from '../assets/blogs/ai-first-business-applications.webp';
import CustomSoftwareForStartupsImage from '../assets/blogs/custom-software-for-startups.webp';
import DigitalMarketingStrategiesForTheModernBusinessBeyondSocialMediaImage from '../assets/blogs/digital-marketing-strategies-for-the-modern-business-beyond-social-media.webp';
import DataAnalyticsAndMachineLearningTransformingDecisionMakingInBusinessImage from '../assets/blogs/data-analytics-and-machine-learning-transforming-decision-making-in-business.webp';
import TheFutureOfWebAndMobileApplicationDevelopmentImage from '../assets/blogs/the-future-of-web-and-mobile-application-development.webp';
import GenerativeAiContentCreationImage from '../assets/blogs/generative-ai-content-creation.webp';
import GenerativeAiContentCreation from '../blogs/generative-ai-content-creation';
import CustomSoftwareForStartups from '../blogs/custom-software-for-startups';
import DigitalMarketingStrategiesForTheModernBusinessBeyondSocialMedia from '../blogs/digital-marketing-strategies-for-the-modern-business-beyond-social-media';
import DataAnalyticsAndMachineLearningTransformingDecisionMakingInBusiness from '../blogs/data-analytics-and-machine-learning-transforming-decision-making-in-business';
import TheFutureOfWebAndMobileApplicationDevelopment from '../blogs/the-future-of-web-and-mobile-application-development';
import AiFirstBusinessApplications from '../blogs/ai-first-business-applications';
import FreeConsultationBanner from '../assets/general/free-consultation-banner.png';


const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`;

const MainContent = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 10px 15px 15px 15px;
  max-width: 1170px;
  margin: 0 auto;
`


const BlogImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
`;

const BlogContent = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 10px 0;
  max-width: 1170px;
  margin: 0 auto;
`

const FreeConsultationBannerImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`

const B = () => {
  const { title, image, link } = useLocation().state;
  const navigate = useNavigate();
  return (
    <MainContainer>
      <PageHeroSection pageTitle={title} />
      <MainContent>
        <BlogImage src={image} alt={title} />
        <BlogContent>
          {link === 'generative-ai-content-creation' && <GenerativeAiContentCreation />}
          {link === 'custom-software-for-startups' && <CustomSoftwareForStartups />}
          {link === 'digital-marketing-strategies-for-the-modern-business-beyond-social-media' && <DigitalMarketingStrategiesForTheModernBusinessBeyondSocialMedia />}
          {link === 'data-analytics-and-machine-learning-transforming-decision-making-in-business' && <DataAnalyticsAndMachineLearningTransformingDecisionMakingInBusiness />}
          {link === 'the-future-of-web-and-mobile-application-development' && <TheFutureOfWebAndMobileApplicationDevelopment />}
          {link === 'ai-first-business-applications' && <AiFirstBusinessApplications />}
        </BlogContent>
        <FreeConsultationBannerImage src={FreeConsultationBanner} alt='Free Consultation Banner' onClick={() => navigate('/contact')} />
      </MainContent>
    </MainContainer>
  )
}

export default B